import { createCitationSourceTypeSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { userRoleSelector } from '@chegg-wt/core/state/user/selectors'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { ReactText } from 'react'
import { fetchUser, refreshAndFetch } from '../../user/actions'

export interface NewRelicPageEventAttributes {
  [key: string]: string | number | ReactText
}

export interface NewRelicPageEvent {
  name: string
  attrs: NewRelicPageEventAttributes
  skip?: boolean
}

export const CITATION_CREATED = 'citationCreated'
export const USER_AUTHENTICATED = 'userAuthenticated'
export const SOFT_LOGIN_DETECTED = 'softLoginDetected'

export const citationCreatedEvent = (action, prevState): NewRelicPageEvent => {
  return {
    name: CITATION_CREATED,
    attrs: {
      style: currentStyleSelector(prevState),
      sourceType: createCitationSourceTypeSelector(prevState),
      userRole: userRoleSelector(prevState),
    },
  }
}

export const userAuthEvent = (
  action: ReturnType<typeof fetchUser>
): NewRelicPageEvent => {
  const { meta } = action
  const event = {
    name: USER_AUTHENTICATED,
    attrs: {},
  }

  if (!meta?.authType) {
    return {
      ...event,
      skip: true,
    }
  }

  return {
    ...event,
    attrs: {
      authType: meta.authType,
    },
  }
}

export const softLoginDetectedEvent = (
  action: ReturnType<typeof refreshAndFetch>
): NewRelicPageEvent => {
  const { meta } = action
  const event = {
    name: SOFT_LOGIN_DETECTED,
    attrs: {},
  }

  if (!meta?.jwt) {
    return {
      ...event,
      skip: true,
    }
  }

  return {
    name: SOFT_LOGIN_DETECTED,
    attrs: {
      jwtExp: meta.jwt.exp,
      jwtSite: meta.jwt.site,
      jwtUserRole: meta.jwt.user_role,
      jwtPaidMember: `${meta.jwt.paidMember}`,
      jwtSessionId: meta.jwt.sessionId,
    },
  }
}
